import React, { FC, Suspense, lazy } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import AuthenticatedLayout from "../../widgets/authenticated-layout";
import LoaderScreen from "../../shared/ui/feedback/LoaderScreen";

const AppointmentListScreen = lazy(
  () => import("../../pages/appointment-list"),
);
const CheckInAppPatientProvideInformationScreen = lazy(
  () => import("../../pages/patient-information/check-in"),
);
const PatientChangeInformationScreen = lazy(
  () => import("../../pages/change-patient-information"),
);
const CheckInAppPatientPrivacyFormScreen = lazy(
  () => import("../../pages/privacy-form/check-in"),
);
const CheckInAppPatientConsentFormScreen = lazy(
  () => import("../../pages/consent-form/check-in"),
);
const CheckInAppointmentScreeningFormScreen = lazy(
  () => import("../../pages/screening-form/check-in"),
);

const AuthenticatedRoot: FC = () => {
  return (
    <Suspense fallback={<LoaderScreen />}>
      <Routes>
        <Route
          path="/"
          element={
            <AuthenticatedLayout>
              <AppointmentListScreen />
            </AuthenticatedLayout>
          }
        />
        <Route
          path="/appointment/:appointmentId/provide-patient-information"
          element={
            <AuthenticatedLayout>
              <CheckInAppPatientProvideInformationScreen />
            </AuthenticatedLayout>
          }
        />
        <Route
          path="/appointment/:appointmentId/change-patient-information"
          element={
            <AuthenticatedLayout>
              <PatientChangeInformationScreen />
            </AuthenticatedLayout>
          }
        />
        <Route
          path="/provide-privacy-form"
          element={
            <AuthenticatedLayout>
              <CheckInAppPatientPrivacyFormScreen />
            </AuthenticatedLayout>
          }
        />
        <Route
          path="/provide-consent-form"
          element={
            <AuthenticatedLayout>
              <CheckInAppPatientConsentFormScreen />
            </AuthenticatedLayout>
          }
        />
        <Route
          path="/provide-screening-form"
          element={
            <AuthenticatedLayout>
              <CheckInAppointmentScreeningFormScreen />
            </AuthenticatedLayout>
          }
        />
        <Route path="*" element={<Navigate replace to="/" />} />
      </Routes>
    </Suspense>
  );
};

export default AuthenticatedRoot;
